import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import QrCode from "@redotech/redo-web/arbiter-icon/qr-code-01.svg";
import { memo } from "react";
import { BlueYonderLocationsButton } from "./blue-yonder-locations-button";

export const BlueYonderQRCard = memo(function BlueYonderQRCard({
  blueYonderQRCodes,
  returnId,
}: {
  blueYonderQRCodes: Array<{
    qrCode: string;
    qrCodeUri?: string | null;
    returnId: string;
    shipmentGroupId: string;
  }>;
  returnId: string;
}) {
  const qrCodeUri = blueYonderQRCodes[0]?.qrCodeUri;

  if (!blueYonderQRCodes.length) {
    return null;
  }

  return (
    <>
      <RedoButton
        hierarchy="secondary"
        IconLeading={QrCode}
        onClick={() => qrCodeUri && window.open(qrCodeUri, "_blank")}
        text="QR code"
      />
      <BlueYonderLocationsButton returnId={returnId} />
    </>
  );
});
